import { PRICE_ON_APPLICATION_LABEL, isPriceOnApplication } from '../../helpers/formatMoney'

const getActiveCurrency = () => {
  const currency = (globalThis as { Shopify?: { currency?: { active?: string } } }).Shopify?.currency?.active;
  return currency || 'AUD';
}

const formatCentsToDollars = (cents: number, productTags?: string[]) => {
  if (isPriceOnApplication(cents, productTags)) {
    return PRICE_ON_APPLICATION_LABEL
  }

  const currency = getActiveCurrency()
  const dollars = cents / 100

  const formattedDollars = dollars.toLocaleString('en-AU', {
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })

  return `${formattedDollars} ${currency}`
}

const formatMoney = (cents: number) => {
  return `${(cents / 100).toLocaleString()} ${getActiveCurrency()}`
}

const formatDollars = (dollars: number) => {
  return `${(dollars).toLocaleString()} ${getActiveCurrency()}`
}

export { formatCentsToDollars, formatMoney, formatDollars }

export const formatYGWG = (text: string) => {
  return text
    .replaceAll("YG", "Yellow Gold")
    .replaceAll("WG", "White Gold")
}